import { memo } from 'react';

import { usePrivateWorkspaceAgentGuidedVariantBrandKits } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantBrandKits';
import { usePrivateWorkspaceAgentGuidedVariantImageSelection } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantImageSelection';
import { WorkspaceAgentGuidedVariantRemoveBackgroundSettings } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantRemoveBackgroundSettings';
import { type WorkspaceAgentGuidedVariantGenerateRequest } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/workspaceAgentGuidedVariantGenerateRequest';

export type PrivateWorkspaceAgentGuidedVariantRemoveBackgroundSettingsProps = {
  onGenerate: (request: WorkspaceAgentGuidedVariantGenerateRequest) => void;
};

export const PrivateWorkspaceAgentGuidedVariantRemoveBackgroundSettings = memo(
  ({ onGenerate }: PrivateWorkspaceAgentGuidedVariantRemoveBackgroundSettingsProps) => {
    const selection = usePrivateWorkspaceAgentGuidedVariantImageSelection();
    const { brandKits, isLoading } = usePrivateWorkspaceAgentGuidedVariantBrandKits();

    return (
      <WorkspaceAgentGuidedVariantRemoveBackgroundSettings
        brandKits={brandKits}
        isBrandKitLoading={isLoading}
        onGenerate={onGenerate}
        selection={selection}
      />
    );
  },
);

PrivateWorkspaceAgentGuidedVariantRemoveBackgroundSettings.displayName =
  'PrivateWorkspaceAgentGuidedVariantRemoveBackgroundSettings';
